<template>
  <div class="c-content">
    <div class="card">
      <div class="card-content">
        <div class="has-text-centered mb-4">
          <h1 class="title has-text-weight-bold"><b>Login</b></h1>
        </div>
        <br />
        <b-message v-if="error" type="is-danger">
          {{ error }}
        </b-message>
        <form autocomplete="off" @submit.prevent="login" method="post">
          <b-field label="Email">
            <b-input
              type="email"
              v-model="email"
              placeholder="Your email"
              required
            >
            </b-input>
          </b-field>

          <b-field label="Kata Sandi">
            <b-input
              type="password"
              v-model="password"
              password-reveal
              placeholder="Your password"
              required
            >
            </b-input>
          </b-field>

          <hr />

          <div class="buttons mt-4">
            <b-button
              type="is-primary"
              native-type="submit"
              :loading="loadingLogin"
              expanded
            >
              Login
            </b-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      rememberMe: false,
      error: "",
      loadingLogin: false,
      hostname: location.host
    };
  },
  mounted() {
    //
  },
  methods: {
    login() {
      this.loadingLogin = true;
      this.$auth
        .login({
          data: {
            email: this.email,
            password: this.password
          },
          staySignedIn: this.rememberMe
        })
        .then(() => {
          const redirectTo = this.$auth.check("App\\SuperAdminProfile")
            ? "questions.index"
            : "dashboard";
          this.$router.push({ name: redirectTo });
        })
        .catch(error => {
          this.loadingLogin = false;

          if (error.response.status === 500) {
            this.error = error.response.data.message;

            this.$buefy.snackbar.open({
              message: "Login failed, please try again later",
              type: "is-warning",
              duration: 5000,
              actionText: "Retry",
              onAction: () => {
                this.submit();
              }
            });
            return;
          }

          const errors = error.response.data.errors;

          if (error.response.status === 400) {
            this.error = errors[Object.keys(errors)[0]][0];
          } else {
            this.error = errors;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.c-content {
  height: 100vh;
  display: flex;
  align-items: center;
}

.c-content .card {
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  border: 2px solid $grey-lighter;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.c-content .card .card-content {
  padding-top: 3rem;
  padding-bottom: 5rem;
}

@media screen and (max-width: 768px) {
  .c-content {
    height: initial;
    display: flex;
    align-items: initial;
  }

  .c-content .card {
    border-width: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
}
</style>
